import {useBaseApi} from "../useBaseApi";
import {StatusCodes} from "http-status-codes";

export function useUserRepository() {

    const {post, get} = useBaseApi();

    const create = async (body) => {
        return await post("/user", body, false);
    }

    const login = async (body) => {
        return await post("/login", body, false);
    }

    const loadCurrentUser = async (token) => {
        try {
            let response = await get("/user/current", true, token);
            return response.data;
        } catch (error) {
            return null;
        }
    }

    const recoverPassword = async (body) => {
        let response =  await post("/user/recover/password", body, false);

        if(response.status === StatusCodes.OK){
            return true;
        }

        return false;
    }

    const recoverPasswordValidate = async (body) => {
        let response =  await post("/user/recover/password/validate", body, false);

        if(response.status === StatusCodes.OK){
            return true;
        }

        return false;
    }

    const validateChangeEmail = async (body, token) => {
        let response =  await post("/user/change/email/validate", body, true, "application/json", token);

        if(response.status === StatusCodes.OK){
            return true;
        }

        return false;
    }

    const validateEmail = async (body) => {
        let response =  await post("/user/validate", body, false);

        if(response.status === StatusCodes.OK){
            return true;
        }

        return false;
    }

    const resendVerificationEmail = async (email) => {
        let response = await post("/user/verification/email/resend", {email}, false);

        if(response && response.status === StatusCodes.OK){
            return true;
        }

        return false;
    }

    return {login, create, loadCurrentUser, recoverPassword, recoverPasswordValidate, validateChangeEmail, validateEmail, resendVerificationEmail};
}
